/**
 * attendanceHistoryApi.js
 * ----------------------
 * API client for Payroll / Attendance History module.
 * Routes directly to FastAPI backend /payroll/attendance-history adhering strictly to
 * module_implementation_standards.md (Rule 90: Zero Mock Data).
 */
import client from '../../../../api/client';

export const attendanceHistoryApi = {
  getAttendanceHistory: async (params = {}) => {
    try {
      const response = await client.get('/payroll/attendance-history/', { params });
      return {
        data: response.data.items || [],
        total: response.data.total_count || (response.data.items || []).length,
        page: params.page || 1,
        pageSize: params.pageSize || 25,
        presentCount: response.data.present_count,
        absentCount: response.data.absent_count,
        lateCount: response.data.late_count,
        leaveCount: response.data.leave_count,
      };
    } catch (err) {
      console.warn('Failed to fetch attendance history:', err);
      return {
        data: [],
        total: 0,
        page: params.page || 1,
        pageSize: params.pageSize || 25,
      };
    }
  },

  getDailySwipes: async (date, empId) => {
    try {
      const response = await client.get('/payroll/attendance-history/swipes', {
        params: { date, emp_id: empId },
      });
      return response.data || [];
    } catch (err) {
      console.warn('Failed to fetch daily swipes:', err);
      return [];
    }
  },
};
